import { useRef, useState } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import api from '../../services/api';
import { useAuth } from '../../hooks/auth';
import { toastError } from '../../toasts';

export const useTamanho = ({
  item,
  handleSetTamanhos,
  setSelectedsSizes,
  setSelecteds,
  selectedsSizes,
  selecteds,
  tamanhos,
  idGrupo,
  moveCard,
  index,
}) => {
  const [editTamanho, setEditTamanho] = useState(null);
  const { id_empresa } = useAuth();
  const tamanhoRef = useRef(null);
  const currentGroupSize = selecteds?.find(
    (groupSize) =>
      groupSize.IdGrupo === idGrupo && groupSize.IdTamanho === item.Id,
  );
  const selected =
    currentGroupSize?.Ativo ||
    !!selectedsSizes?.find((_item) => _item.Id === item.Id);

  const [{ handlerId }, drop] = useDrop({
    accept: 'tamanho',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!tamanhoRef.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = tamanhoRef.current?.getBoundingClientRect();

      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY * 0.5) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY * 1.5) {
        return;
      }
      moveCard(dragIndex, hoverIndex);

      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'tamanho',
    item: () => {
      return { Id: item.Id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(tamanhoRef));

  function handleEditTamanho(item) {
    setEditTamanho(item);
  }

  async function handleSaveEdit(item) {
    await api.patch(`tamanho/alterar/${item.Id}`, {
      ...editTamanho,
    });

    handleSetTamanhos(() =>
      tamanhos?.map((tam) => (tam.Id === item.Id ? editTamanho : tam)),
    );
    setEditTamanho(null);
  }

  const handleActiveInactive = async (item) => {
    const new_item_data = {
      ...item,
      Ativo: !item.Ativo,
    };

    await api.patch(`tamanho/alterar/${item.Id}`, new_item_data);

    handleSetTamanhos(() =>
      tamanhos?.map((tam) => (tam.Id === item.Id ? new_item_data : tam)),
    );
  };

  async function handleSelectSize() {
    try {
      if (!idGrupo) {
        return setSelectedsSizes((prev) => {
          const _item = prev?.find((_item_find) => _item_find.Id === item.Id);
          if (_item) {
            return prev?.filter((_curr_item) => _curr_item.Id !== item.Id);
          }
          return [...prev, item];
        });
      }

      if (currentGroupSize) {
        await api.patch(`grupo-tamanhos/${currentGroupSize?.Id}`, {
          Ativo: !currentGroupSize.Ativo,
        });
        setSelecteds((prev) =>
          prev?.map((_prev) =>
            _prev.Id !== currentGroupSize?.Id
              ? _prev
              : {
                  ...currentGroupSize,
                  Ativo: !currentGroupSize.Ativo,
                },
          ),
        );
        return;
      }

      const res = await api.post('grupo-tamanhos', {
        IdGrupo: idGrupo,
        IdEmpresa: id_empresa,
        IdTamanho: item.Id,
        Ativo: true,
      });

      setSelecteds((prev) => [...prev, res.data]);
    } catch (err) {
      toastError('Não foi possivel alterar seleção do tamanho!');
      console.log(err);
    }
  }

  return {
    selected,
    editTamanho,
    tamanhoRef,
    isDragging,
    handlerId,
    handleEditTamanho,
    setEditTamanho,
    handleSaveEdit,
    handleSelectSize,
    handleActiveInactive,
  };
};
